module.exports = __webpack_public_path__ + "static/media/recovery-typography.d3ae7637.png";